export default __webpack_public_path__ + "static/media/18.b769d074.jpeg";